import { withChartLayout } from 'components/common';
import InfantToddlerAssessment from 'components/features/chart/admission-history/infant-toddler-assessment/InfantToddlerAssessment';

const InfantToddlerAssessmentPage = withChartLayout('Infant - Toddler Risk Assessment')(InfantToddlerAssessment);
export default InfantToddlerAssessmentPage;
